import {
  Card,
  Flex,
  Group,
  Avatar,
  Button,
  Stack,
  Text,
  Image,
  Switch,
  Box,
} from "@mantine/core";
import { BookIcon, UniversityIcon } from "../../static/icons/Icons";

export const SingleCardView = ({ ambassador }: { ambassador: any }) => {
  return (
    <Stack p={12}>
      <Card
        key={ambassador?.id}
        w="100%"
        mih="275px"
        shadow="sm"
        padding="lg"
        radius="md"
        withBorder
        mt={10}
      >
        <Flex
          h="100%"
          direction="column"
          justify="space-between"
          align="space-between"
          gap="md"
        >
          <Flex justify="space-between" align="start">
            <Group wrap="nowrap">
              <Avatar
                src={ambassador?.userInfo?.profile_picture_url}
                size="xl"
              />
              <Flex wrap="wrap" gap="xs" direction="column">
                <Text size="18px" fw={700}>
                  {`${ambassador?.userInfo?.first_name || "__"}${
                    ambassador?.userInfo?.last_name
                      ? " " + ambassador.userInfo.last_name
                      : ""
                  }`}
                </Text>
                {/* {ambassador?.institution_data?.name && ( */}
                <Group wrap="nowrap">
                  <Box h={20} w={20}>
                    <UniversityIcon />
                  </Box>
                  <Text size="14px" c="#5F6368" fw={400}>
                    {ambassador?.institution_data?.name ?? "__"}
                  </Text>
                </Group>
                {/* )} */}
                {/* {ambassador?.program_data?.name && ( */}
                <Group wrap="nowrap">
                  <Box h={20} w={20}>
                    <BookIcon color="gray" />
                  </Box>
                  <Text size="14px" c="#5F6368" fw={400}>
                    {ambassador?.program_data?.name ?? "__"}
                  </Text>
                </Group>
                {/* )} */}
              </Flex>
            </Group>
            {ambassador?.institution_data?.country_data?.icon_url && (
              <Image
                src={ambassador?.institution_data?.country_data?.icon_url}
                alt="flag"
                width={24}
                height={24}
              />
            )}
          </Flex>
          <Flex
            wrap="wrap"
            align="center"
            gap="0.5rem"
            mt={12}
            c="dimmed"
            fz="sm"
            justify="space-between"
          >
            {/* {ambassador?.country_of_origin?.name && ( */}
            <Group>
              <Text size="14px" span c="dimmed">
                Country:
              </Text>{" "}
              <Text size="14px" span c="black">
                {ambassador?.country_of_origin?.name ?? "__"}
              </Text>{" "}
            </Group>
            {/* )} */}
            {/* {ambassador?.state_of_origin?.name && ( */}
            <Group>
              <Text size="14px" span c="dimmed">
                State:
              </Text>{" "}
              <Text size="14px" span c="black">
                {ambassador?.state_of_origin?.name ?? "__"}
              </Text>{" "}
            </Group>
            {/* )} */}
            {/* {ambassador?.city_of_origin?.name && ( */}
            <Group>
              <Text size="14px" span c="dimmed">
                City:
              </Text>{" "}
              <Text size="14px" span c="black">
                {ambassador?.city_of_origin?.name ?? "__"}
              </Text>
            </Group>
            {/* )} */}
          </Flex>
          <Text c="dimmed" size="14px" span>
            {ambassador?.bio}
          </Text>
          <Flex
            gap="sm"
            wrap="wrap"
            justify="space-between"
            mt="md"
            align="end"
          >
            <Button variant="outline">
              Chat with {ambassador?.userInfo?.first_name}
            </Button>
            <Group align="end" pb={5}>
              <Text size="sm">Part of Widget</Text>
              <Switch
                color="#8AC640"
                checked={ambassador?.is_visible_in_widget === 1 ? true : false}
              />
            </Group>
          </Flex>
        </Flex>
      </Card>
    </Stack>
  );
};
